<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="8">
                    <h1 class="headline font-weight-light mb-3">
                        VIEW TRANSFER
                    </h1>
                </v-col>
                <v-col :cols="4" class="text-right">
                    <v-text-field
                        v-model="form_search_singlepart"
                        label="Search Singlepart / Enter"
                        single-line
                        solo
                        rounded
                        dense
                        @keyup.enter="func_search_sg()"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    v-if="team_name === 'INVENTORY'"
                    class="mar-t-20"
                >
                    <v-btn
                        color="primary"
                        dark
                        small
                        rounded
                        class="mr-1"
                        @click="get_dialogTranfer()"
                    >
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Multi Tranfers
                    </v-btn>
                </v-col>
            </v-row>

            <div class="mt-2">
                <v-row>
                    <v-col cols="11" sm="6" md="3">
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="dateRangeText"
                                    label="Date range"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dates"
                                range
                                @change="get_date()"
                            ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                        v-if="team_name === 'INVENTORY'"
                        cols="11"
                        sm="6"
                        md="3"
                    >
                        <v-autocomplete
                            :items="data_branch"
                            item-text="branch_name"
                            item-value="branch_id"
                            v-model="form.branch"
                            menu-props="auto"
                            label="Select Branch"
                            hide-details
                            @change="searchTranfer()"
                        ></v-autocomplete>
                    </v-col>
                    <v-col v-if="team_name === 'ODM'" cols="11" sm="6" md="3">
                        <v-autocomplete
                            :items="data_engineer"
                            item-text="emp_name_en"
                            item-value="emp_id"
                            menu-props="auto"
                            label="Select Engineer"
                            v-model="form.engineer"
                            hide-details
                            @change="searchTranfer()"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="11" sm="6" md="3">
                        <v-text-field
                            v-model="form.value"
                            label="Single / Serial"
                            prepend-inner-icon="mdi-magnify"
                            @keyup="searchTranfer($event.target.value)"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="1" sm="6" md="3" class="mt-4">
                        <v-btn
                            x-small
                            fab
                            class="mr-1"
                            @click="reset()"
                            v-if="
                                dateRangeText != '' ||
                                    form.branch != '' ||
                                    form.value != '' ||
                                    form.engineer != ''
                            "
                        >
                            <v-icon>mdi-rotate-left</v-icon></v-btn
                        >
                    </v-col>
                </v-row>
            </div>
            <v-card class="pa-3">
                <div
                    v-for="(row, index_1) in data_tranfer"
                    :key="row.transfer_id"
                >
                    <hr v-if="index_1 != 0" />
                    <hr v-if="index_1 != 0" />
                    <v-row>
                        <v-col cols="12" sm="6" md="3"
                            ><b>To : </b>{{ row.branch_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="3"
                            ><b>Status : </b>{{ row.status }}</v-col
                        >
                        <v-col cols="12" sm="6" md="6" class="text-right"
                            ><v-btn
                                rounded
                                small
                                class="mr-1"
                                color="green accent-2"
                                @click="receive(row.transfer_id)"
                                v-if="row.status != 'received'"
                            >
                                <v-icon class="mr-1" dark small
                                    >mdi-package-down</v-icon
                                >
                                Receive</v-btn
                            >
                            <v-btn
                                rounded
                                small
                                @click="print(row.transfer_id)"
                            >
                                <v-icon class="mr-1" dark small
                                    >mdi-printer</v-icon
                                >
                                Print</v-btn
                            >
                        </v-col>
                        <v-col cols="12" sm="6" md="3"
                            ><b>Created At : </b>{{ row.created_date }}</v-col
                        >
                        <v-col cols="12" sm="6" md="3"
                            ><b>Created By : </b>{{ row.created_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="3"
                            ><b>Received At : </b>{{ row.received_date }}</v-col
                        >
                        <v-col cols="12" sm="6" md="3"
                            ><b>Received By : </b>{{ row.received_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="3"
                            ><b>Packinglist Date : </b
                            >{{ row.packing_date }}</v-col
                        >
                        <v-col cols="12" sm="6" md="3"
                            ><b>Packinglist By : </b
                            >{{ row.packing_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="3"
                            ><b>Packinglist No : </b>{{ row.packing_no }}</v-col
                        >

                        <v-col
                            cols="12 pa-0 mb-5 mt-1"
                            v-if="row.transfer_detail.length > 0"
                        >
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center">Part No</th>
                                            <th class="text-center">
                                                Part Desc.
                                            </th>
                                            <th class="text-center">
                                                Singlepart
                                            </th>
                                            <th class="text-center">Serial</th>
                                            <th class="text-center">Status</th>
                                            <th class="text-center">Remark</th>
                                            <th class="text-center">Cancel</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(item,
                                            index) in row.transfer_detail"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ item.row_number }}.
                                            </td>
                                            <td class="text-center">
                                                {{ item.part_name }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.part_description }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.singlepart }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.serial }}
                                            </td>
                                            <td class="text-center">
                                                {{ item.detail_status }}
                                            </td>
                                            <td>
                                                {{ item.detail_remark }}
                                            </td>
                                            <td class="text-center">
                                                <v-btn
                                                    fab
                                                    x-small
                                                    color="red accent-2"
                                                    @click="
                                                        change_remove_tranfer(
                                                            item.detail_id
                                                        )
                                                    "
                                                >
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div>
                            <v-btn class="mx-2" fab small @click="back()">
                                <v-icon dark>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color(n)"
                                v-for="n in page_count"
                                :key="n"
                                @click="get_tranfer_page(page_num_show(n))"
                            >
                                {{ page_num_show(n) }}
                            </v-btn>

                            <v-btn class="mx-2" fab small @click="next()">
                                <v-icon dark>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>

        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">RECEIVE PART</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th class="text-center">
                                                #
                                            </th>
                                            <th class="text-center">
                                                Part No
                                            </th>
                                            <th class="text-center">
                                                Part Desc.
                                            </th>
                                            <th class="text-center">
                                                Singlepart
                                            </th>
                                            <th class="text-center">
                                                Serial
                                            </th>
                                            <th class="text-center">
                                                Receive
                                            </th>
                                            <th class="text-center">
                                                Remark
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="n in transfer_detail"
                                            :key="n.detail_id"
                                        >
                                            <td class="text-center">
                                                {{ n.row_number }}.
                                            </td>
                                            <td class="text-center">
                                                {{ n.part_name }}
                                            </td>
                                            <td class="text-center">
                                                {{ n.part_description }}
                                            </td>
                                            <td class="text-center">
                                                {{ n.singlepart }}
                                            </td>
                                            <td class="text-center">
                                                {{ n.serial }}
                                            </td>
                                            <td>
                                                <v-radio-group column>
                                                    <v-radio
                                                        label="Receive"
                                                        value="receive"
                                                        @change="
                                                            chk_receive(
                                                                'receive',
                                                                n.row_number,
                                                                n.detail_id
                                                            )
                                                        "
                                                    ></v-radio>
                                                    <v-radio
                                                        label="Not Receive"
                                                        value="not_receive"
                                                        @change="
                                                            chk_receive(
                                                                'not_receive',
                                                                n.row_number,
                                                                n.detail_id
                                                            )
                                                        "
                                                    ></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td class="text-center">
                                                <v-text-field
                                                    v-if="
                                                        chk_remark[
                                                            n.detail_id
                                                        ] === true
                                                    "
                                                    v-model="
                                                        data_save_receive[
                                                            n.detail_id
                                                        ].remark
                                                    "
                                                    label="Remark"
                                                ></v-text-field>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="" rounded small @click="close">Cancel</v-btn>
                    <v-btn
                        color="success darken-1"
                        rounded
                        small
                        @click="save_receive()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <v-dialog
            v-model="dialogTranfer"
            :max-width="chk_multi_tranfer == 1 ? '550px' : '1000px'"
            persistent
        >
            <v-card>
                <v-card-title>
                    <span class="headline">MULTI TRANFER</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" v-if="chk_multi_tranfer == 1">
                                <v-autocomplete
                                    :items="data_branch"
                                    item-text="branch_name"
                                    item-value="branch_id"
                                    v-model="form_ml_branch"
                                    menu-props="auto"
                                    label="Select Branch"
                                    hide-details
                                    dense
                                    outlined
                                    class="mb-3"
                                    @change="searchTranfer()"
                                ></v-autocomplete>
                                <v-textarea
                                    outlined
                                    label="Multi tranfer..."
                                    required
                                    v-model="form_ml_tranfer"
                                ></v-textarea>
                            </v-col>
                            <v-col
                                cols="12"
                                v-if="chk_multi_tranfer == 2"
                                class="mar-t-10"
                            >
                                <v-chip
                                    :color="
                                        data_ml_tranfer.status == 'error'
                                            ? 'red accent-2'
                                            : 'teal accent-3'
                                    "
                                    >{{
                                        "Status : " + data_ml_tranfer.status
                                    }}</v-chip
                                >
                                <v-simple-table class="table-inv mt-2">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">#</th>
                                                <th class="text-center">
                                                    Part name
                                                </th>
                                                <th class="text-center">
                                                    Part description
                                                </th>
                                                <th class="text-center">
                                                    Project name
                                                </th>
                                                <th class="text-center">
                                                    Singlepart
                                                </th>
                                                <th class="text-center">
                                                    Remark
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(r,
                                                i) in data_ml_tranfer.data"
                                                :key="i"
                                            >
                                                <td class="text-center">
                                                    {{ i + 1 }}.
                                                </td>
                                                <td>
                                                    {{ r.part_name }}
                                                </td>
                                                <td>
                                                    {{ r.part_description }}
                                                </td>
                                                <td>
                                                    {{ r.project_name }}
                                                </td>
                                                <td>
                                                    {{ r.singlepart }}
                                                </td>
                                                <td>
                                                    {{ r.remark }}
                                                </td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions class="mar-t-30">
                    <v-btn text @click="closeIssue()">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="chk_multi_tranfer == 1"
                        :disabled="
                            form_ml_tranfer == '' || form_ml_branch == ''
                        "
                        color="success darken-1"
                        rounded
                        @click="save_multi_tranfer()"
                        >Save</v-btn
                    >
                    <v-btn
                        v-if="chk_multi_tranfer == 2"
                        :disabled="data_ml_tranfer.status == 'error'"
                        color="success darken-1"
                        rounded
                        @click="save_multi_tranfer()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"

const url = `${process.env.VUE_APP_ROOT_API}/api/transfer`
import { mapState, mapMutations } from "vuex"

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
        if (this.team_name == "ODM") {
            this.get_engineer()
        } else {
            this.get_branch()
        }
    },
    created() {
        this.searchTranfer = _.debounce(this.searchTranfer, 300)
    },
    computed: {
        ...mapState(["snackbar"]),

        dateRangeText() {
            this.dates.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.dates.join(" ~ ")
        },
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            let { data } = await axios.post(url, {}, this.tk)
            this.data_main = data
            this.data_tranfer = data.data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)
        },
        async back() {
            let url = this.data_main.prev_page_url
            let { data } = await axios.post(url, {}, this.tk)
            this.data_tranfer = data.data
            this.data_main = data
        },
        async next() {
            let url = this.data_main.next_page_url
            let { data } = await axios.post(url, {}, this.tk)
            this.data_tranfer = data.data
            this.data_main = data
        },
        async get_tranfer_page(num) {
            this.current_page = num
            if (num != "...") {
                let url_page = url + "?page=" + num
                let { data } = await axios.post(url_page, {}, this.tk)
                this.data_tranfer = data.data
                this.data_main = data
            }
        },
        async get_engineer() {
            let url = `${process.env.VUE_APP_ROOT_API}/api/svc-zone-ce/1/1`
            let { data } = await axios.get(url, this.tk)
            this.data_engineer = data[0].engineer
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_main.current_page <= 4) {
                    return this.data_main.current_page === n ? "primary" : ""
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_main.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_main.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_main.current_page - 1
                    chk4 = this.data_main.current_page
                    chk5 = this.data_main.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_main.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        async save_receive() {
            let sendData = this.data_save_receive
            await axios
                .put(
                    url + "/receive/" + this.transferId,
                    { sendData: sendData },
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    }
                )
                .then((response) => {
                    this.close()
                    this.get_data()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    this.chk_data = true
                })
        },
        async receive(transfer_id) {
            this.transferId = transfer_id
            await axios.get(url + "/" + transfer_id).then((response) => {
                this.transfer_detail = response.data.transfer_detail
                this.dialog = true
            })
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.searchTranfer()
                this.menu2 = false
            }
        },
        async searchTranfer() {
            let datasent = {
                branch: this.form.branch,
                engineer_id: this.form.engineer,
                date: this.dates,
                value: this.form.value,
            }
            let { data } = await axios.post(url, datasent, this.tk)
            // console.log(data, "ds");
            this.data_main = data
            this.data_tranfer = data.data
            this.page_count = 1
        },
        async get_branch() {
            let { data } = await axios.get(
                `${process.env.VUE_APP_ROOT_API}/api/getbranch`
            )
            this.data_branch = data
        },
        reset() {
            this.form.branch = ""
            this.dates = []
            this.form.value = ""
            this.form.engineer = ""
            this.get_data()
        },
        print(transfer_id) {
            let url_print = "/Inventory/Transfer-Print/" + transfer_id
            this.$router.push(url_print)
        },
        close() {
            // this.get_data()
            this.dialog = false
        },
        chk_receive(e, row_number, detail_id) {
            this.$set(this.data_save_receive, row_number, {
                receive: e,
                detail_id: detail_id,
                remark: "",
            })
            this.$set(
                this.chk_remark,
                row_number,
                e === "not_receive" ? true : false
            )
        },
        async change_remove_tranfer(detail_id) {
            this.$swal({
                title: "Are you sure you want to remove ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .get(
                            `${process.env.VUE_APP_ROOT_API}/api/transfer-cancel/` +
                                detail_id,
                            this.tk
                        )
                        .then((response) => {
                            this.get_data()
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            this.chk_data = true
                        })
                }
            })
        },
        get_dialogTranfer() {
            this.chk_multi_tranfer = 1
            this.dialogTranfer = true
        },
        async save_multi_tranfer() {
            let send = {
                branch_id: this.form_ml_branch,
                textarea: this.form_ml_tranfer,
            }
            if (this.chk_multi_tranfer == 1) {
                await axios
                    .post(
                        `${process.env.VUE_APP_ROOT_API}/api/multi-transfer/check`,
                        send,
                        this.tk
                    )
                    .then((response) => {
                        this.data_ml_tranfer = response.data
                        this.chk_multi_tranfer = 2
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else if (this.chk_multi_tranfer == 2) {
                await axios
                    .post(
                        `${process.env.VUE_APP_ROOT_API}/api/multi-transfer/save`,
                        send,
                        this.tk
                    )
                    .then((response) => {
                        this.chk_multi_tranfer = 0
                        this.get_data()
                        this.closeIssue()
                        this.mutatesnackbar()
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        closeIssue() {
            if (this.chk_multi_tranfer == 2) {
                this.chk_multi_tranfer = 1
            }
            this.form_ml_branch = ""
            this.form_ml_tranfer = ""
            this.dialogTranfer = false
        },
        async func_search_sg() {
            let routeData = this.$router.resolve({
                path: "/Search-Parts",
                query: { q: this.form_search_singlepart },
            })
            window.open(routeData.href, "_blank")
        },
    },
    data() {
        return {
            data_tranfer: [],
            data_main: [],
            data_branch: [],
            data_engineer: [],
            page_count: 0,
            transfer_detail: [],
            // data_save_receive: {
            //     receive: [],
            //     remark: [],
            // },
            data_save_receive: [],
            dates: [],
            text: "Success, Your work has been saved",
            form: {
                branch: "",
                value: "",
            },
            menu2: false,
            dialog: false,
            chk_remark: [],
            transferId: 0,
            team_name: localStorage.team_name,
            tk: "",
            dialogTranfer: false,
            chk_multi_tranfer: 0,
            form_ml_tranfer: "",
            form_ml_branch: "",
            data_ml_tranfer: [],
            form_search_singlepart: "",
        }
    },
}
</script>
